import React from 'react';
//carousel
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'src/asset/scss/plugin/slick.scss'

export default function MarketDetailImgList(props) {
    const { list } = props;//props

    /* =============== 슬라이더옵션 =============== */
    const SliderSettings = {
        arrows: false,
        dots: true,
        infinite: true,
        autoplay: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: false,
    }
    /* =============== 슬라이더옵션 =============== */

    return (
        <>
        {list.length > 1 ?
            <Slider {...SliderSettings}>
                {list.map((item, idx) => 
                    <img key={idx} src={`${process.env.REACT_APP_IMAGE_URL + item.IMG_SRC}`} alt={'마켓 상품'} />
                )}
            </Slider>
        : <img src={`${process.env.REACT_APP_IMAGE_URL + list[0].IMG_SRC}`} alt={'마켓 상품'} /> }
        </>
    );
}